import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Stack, Alert, CircularProgress } from '@mui/material';
import { useProductoForm } from '../hooks';
import { ProductForm } from '../components';
import { ImagenProducto } from '../types/producto.types';
import { ProductoService } from '../services';

export function ProductFormPage() {
  const navigate = useNavigate();
  const [imagenes, setImagenes] = useState<ImagenProducto[]>([]);
  const [imagenesOriginales, setImagenesOriginales] = useState<ImagenProducto[]>([]);
  const [sincronizandoImagenes, setSincronizandoImagenes] = useState(false);
  const [errorImagenes, setErrorImagenes] = useState<string | null>(null);

  const { formData, loading, error, handleChange, handleSubmit: hookSubmit } = useProductoForm(
    undefined, // No initialData = creating new product
    async (producto) => {
      // Post-creation success: navigate back to list
      navigate('/productos/listar');
    }
  );

  const handleCancel = () => {
    navigate('/productos/listar');
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate images if needed
    if (errorImagenes && !sincronizandoImagenes) {
      return;
    }

    await hookSubmit(e);
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
            Nuevo Producto
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Completa los campos para crear un nuevo producto en el inventario
          </Typography>
        </Box>

        {errorImagenes && (
          <Alert severity={sincronizandoImagenes ? 'info' : 'warning'}>
            {errorImagenes}
          </Alert>
        )}

        <Box sx={{ position: 'relative' }}>
          {loading && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 10,
              }}
            >
              <CircularProgress size={40} />
            </Box>
          )}
          <ProductForm
            formData={formData}
            loading={loading || sincronizandoImagenes}
            error={error}
            isEditing={false}
            onChange={handleChange}
            onSubmit={handleFormSubmit}
            onCancel={handleCancel}
            imagenes={imagenes}
            onImagenesChange={setImagenes}
          />
        </Box>
      </Stack>
    </Container>
  );
}
